import { useEffect, useRef, useState } from 'react'
import { SettingSlider } from '../../../../../components/sliders/settingSlider/SettingSlider'
import { translations } from '../../../../../configs/translations'
import { useStore } from '../../../../../store/store'
import { FineTuningCache } from '../../../FineTuning.cache'
import { EFineTuningSettingNames } from '../../../FineTuning.enum'
import { FineTuningSettingInformation } from '../fineTuningSettingInformation/FineTuningSettingInformation'
import './FineTuningSetting.css'
import { FineTuningSettingProps } from './FineTuningSetting.types'

export const FineTuningSetting = ({
	name,
	translation,
	type,
	symbol,
	onHover,
	onUnhover,
	slider,
	information,
	setFineTuningSettingsRef,
	profileName,
	activeComponent,
}: FineTuningSettingProps) => {

	const language = useStore(state => state.language)
	const t = translations[language]
	const [cacheService, setCacheService] = useState<FineTuningCache | null>(null)
	const [value, setValue] = useState(slider.initialValue)
	const [initialValue, setInitialValue] = useState(slider.initialValue)
	const [max, setMax] = useState(slider.max)
	const [min, setMin] = useState(slider.min)
	const ref = useRef<HTMLDivElement>(null)
	const [marginTop, setMarginTop] = useState(0)

	useEffect(() => {
		if (ref.current) {
			setMarginTop(ref.current.offsetTop)
		}
	}, [])

	useEffect(() => {
		const cache = FineTuningCache.getInstance()
		setCacheService(cache)
		const cachedValue = cache.getValueFromCache(name as EFineTuningSettingNames, cache.getCache(), profileName)
		setMin(slider.min)
		setMax(slider.max)
		if (cachedValue == null || cachedValue == undefined) {
			setValue(slider.min)
			setInitialValue(slider.min)
		} else {
			setValue(cachedValue)
			setInitialValue(cachedValue)
		}
		setFineTuningSettingsRef(prev => prev + 1)
	}, [activeComponent])

	const handleChange = (value: number) => {
		setValue(value)
		if (cacheService) {
			FineTuningCache.getInstance().updateCache(name as EFineTuningSettingNames, value, profileName)
			setFineTuningSettingsRef(prev => prev + 1)
		}
	}

	useEffect(() => {
		if (max === null && value) {
			setMax(Number((value * 1.1).toFixed(0)))
		}
		if (min === null && value) {
			setMin(Number((value * 0.85).toFixed(0)))
		}
	}, [value])


	return (
		<>
			<div
				onMouseEnter={onHover}
				onMouseLeave={onUnhover}
				className={`fine-tuning-setting ${type}`}
				ref={ref}
			>
				<div className='fine-tuning-setting-header'>
					<p className='fine-tuning-setting-header-p'>{t[translation as keyof typeof t]}</p>
				</div>

				<div className='fine-tuning-setting-slider-wrapper' ref={ref}>
					<SettingSlider
						key={`${profileName}-${activeComponent}`}
						name={""}
						type={type}
						min={min}
						max={max}
						step={slider.step}
						value={value}
						onChange={handleChange}
						initialValue={initialValue}
						showCenterMarker={slider.showCenterMarker}
					/>

					<div className='fine-tuning-setting-slider-wrapper-value'>
						{type === 'disabled' ? <img src="./icons/24px/lock.png" alt="lock" /> :
							<p>{value}<span className='fine-tuning-setting-slider-wrapper-value-symbol'>{t[symbol as keyof typeof t]}</span></p>}
					</div>

				</div>

			</div>

			{type === 'active' && <FineTuningSettingInformation
				header={t[translation as keyof typeof t]}
				topMargin={marginTop}
				information={t[information as keyof typeof t]}
			/>}

		</>
	)
}